/* eslint-disable array-callback-return */
import { message } from "antd";
import {GoogleAuthProvider, updateProfile } from "firebase/auth";
import {AuthIdb} from '../../../data'
import ActionTypes, { ActionProduct} from "../actionTypes"

import { getDatabase, ref, onValue, push, remove, set } from 'firebase/database';
import Cookies from "js-cookie";
const db = getDatabase();
const UnixUser = `user-${Math.random().toString(36)}`;

const registerInitate = (email, password, name) => (dispatch) => {
  AuthIdb.registerUser(email, password).then((res) => {
    updateProfile(res.user, {
        name,
    });
    const dataUser = {
      name: name,
      email: res.user.email,
      uid: res.user.uid,
    };
    set(ref(db, `users/${res.user.uid}`), dataUser );
    Cookies.set('user', UnixUser, { expires: 1 });
    dispatch({type:ActionTypes.ISLOGIN, value: true});
    dispatch({ type: ActionTypes.CHANGE_USER, value: dataUser });
  }).catch((err) => {
    message.error(err.message);
  })
};

const loginInitiate = (email, password) => (dispatch) => {
  dispatch({ type: ActionTypes.IS_LOADING, value: true });
  AuthIdb.loginUser(email, password)
    .then(() => {
      Cookies.set('user', UnixUser, { expires: 1 });
      dispatch({ type: ActionTypes.IS_LOADING, value: false });
      dispatch({ type: ActionTypes.ISLOGIN, value: true });
    })
    .catch((err) => {
      dispatch({ type: ActionTypes.IS_LOADING, value: false });
      message.error(err.message);
    });
}

const logoutInitiate = () => (dispatch) => {
  AuthIdb.logoutUser().then(() => {
    Cookies.remove('user');
    dispatch({ type: ActionTypes.ISLOGIN, value: false });
    message.success('Succes Logout, Sampai Jumpa Lagi', [3]);
  }).catch((err) => {
     message.error(err.message);
  })
}

const loginGoogle = () => (dispatch) => {
  AuthIdb.loginGoogle().then((res) => {
    const credential = GoogleAuthProvider.credentialFromResult(res);
    const token = credential.accessToken;
     const dataLoginGoogle = {
       name: res.user.displayName,
       email: res.user.email,
       photo: res.user.photoURL,
       uid: res.user.uid,
     };
     set(ref(db, `users/${res.user.uid}`), dataLoginGoogle);
      Cookies.set('user', token, { expires: 1 });
     dispatch({ type: ActionTypes.ISLOGIN, value: true });
     dispatch({type:ActionTypes.CHANGE_USER_GOOGLE_LOGIN, value:dataLoginGoogle});
  }).catch((err)=>message.error(err.message)
  )
}

const getDataUser = () => (dispatch) => {
  dispatch({type: ActionTypes.IS_LOADING, value: true});
  const starCountRef = ref(db, 'users');
  return new Promise((resolve) => {
    onValue(starCountRef, (snapshot) => {
      const data = [];
      const dataSnapshot = snapshot.val();
      if(dataSnapshot !== null){
        Object.keys(dataSnapshot).map((key) => {
          data.push({
            id: key,
            data: dataSnapshot[key]
          })
        })
      }
      dispatch({ type: ActionProduct.IS_LOADING, value: false });
      resolve(data);
    });
  });
}

// shirt

const AddDataShirt = (data) => (dispatch) => {
  dispatch({ type: ActionProduct.IS_LOADING, value: true });
  push(ref(db, 'shirts/'), data)
    .then((res) => {
      dispatch({ type: ActionProduct.IS_LOADING, value: false });
      dispatch({type: ActionProduct.SUCCESS_CREATE, value:true});
    })
    .catch((err) => message.error(err.message));
};

const getShirt = () => (dispatch)  => {
  dispatch({ type: ActionProduct.IS_LOADING, value: true });
  const starCountRef = ref(db, 'shirts');
  return new Promise((resolve) => {
    onValue(starCountRef, (snapshot) => {
      const data = [];
      const dataSnapshot = snapshot.val();
      if (dataSnapshot !== null) {
        // eslint-disable-next-line array-callback-return
        Object.keys(dataSnapshot).map((key) => {
          data.push({
            id: key,
            data: dataSnapshot[key],
          });
        });
      }
      dispatch({ type: ActionProduct.IS_LOADING, value: false });
      resolve(data);
    });
  });
}

const deleteShirt = (id) => (dispatch) => {
  const starCountRef = ref(db, `shirts/${id}`);
  remove(starCountRef)
    .then((res) => {
      message.success('Data Berhasil Di hapus');
    })
    .catch((err) => message.error(err.message));
}

const getShirtById = (id) => {
   const starCountRef = ref(db, `shirts/${id}`);
    return new Promise((resolve) => {
      onValue(starCountRef, (snapshot) => {
        const data = snapshot.val();
        resolve(data);
      });
    })
}

const updateDataShirt = (id, data) => (dispatch) => {
  dispatch({ type: ActionProduct.IS_LOADING, value: true });
  set(ref(db, `shirts/${id}`), data)
    .then(() => {
      dispatch({ type: ActionProduct.IS_LOADING, value: false });
      dispatch({ type: ActionProduct.SUCCESS_UPDATE, value: true });
    })
    .catch((err) => message.error(err.message));
};

// Trouser
const addDataTrouser = (data) => (dispatch) => {
  dispatch({ type: ActionProduct.IS_LOADING, value: true });
  push(ref(db, 'trousers/'), data).then((res) => {
    message.success('data added successfully');
    dispatch({ type: ActionProduct.IS_LOADING, value: false });
    dispatch({ type: ActionProduct.SUCCESS_CREATE, value: true });
  }).catch((err) => message.error(err.message));
}

const getDataTrouser = () => (dispatch) => {
  dispatch({ type: ActionProduct.IS_LOADING, value: true });
  const starCountRef = ref(db, 'trousers');
  return new Promise((resolve) => {
    onValue(starCountRef, (snapshot) => {
      const data = [];
      const dataSnapshot = snapshot.val();
      if(dataSnapshot !== null){
        Object.keys(dataSnapshot).map((key) => {
          data.push({
            id: key,
            data: dataSnapshot[key]
          })
        })
      }
      dispatch({ type: ActionProduct.IS_LOADING, value: false });
      resolve(data);
    });
  });
}

const getDataTrouserById =(id)  => {
  const starCountRef = ref(db, `trousers/${id}`);
  return new Promise((resolve) => {
    onValue(starCountRef, (snapshot) => {
      const data = snapshot.val();
      resolve(data);
    });
  });
}

const updateDataTrouser = (id, data) => (dispatch) => {
  dispatch({ type: ActionProduct.IS_LOADING, value: true });
  set(ref(db, `trousers/${id}`), data)
    .then(() => {
      dispatch({ type: ActionProduct.IS_LOADING, value: false });
      dispatch({ type: ActionProduct.SUCCESS_UPDATE, value: true });
    })
    .catch((err) => message.error(err.message));
};

const deleteDataTrouser = (id) => () => {
  const starCountRef = ref(db, `trousers/${id}`);
  remove(starCountRef)
    .then(() => {
      message.success('Data Delete Successfully');
    })
    .catch((err) => message.error(err.message));
}


//jacket

const AddDataJacket = (data) => (dispatch) => {
  dispatch({ type: ActionProduct.IS_LOADING, value: true });
  push(ref(db, 'jackets/'), data)
    .then((res) => {
      dispatch({ type: ActionProduct.IS_LOADING, value: false });
      dispatch({ type: ActionProduct.SUCCESS_CREATE, value: true });
    })
    .catch((err) => message.error(err.message));
};

const getDataJacket = () => (dispatch) => {
  dispatch({ type: ActionProduct.IS_LOADING, value: true });
  const starCountRef = ref(db, 'jackets');
  return new Promise((resolve) => {
    onValue(starCountRef, (snapshot) => {
      const data = [];
      const dataSnapshot = snapshot.val();
      if (dataSnapshot !== null) {
        Object.keys(dataSnapshot).map((key) => {
          data.push({
            id: key,
            data: dataSnapshot[key],
          });
        });
      }
      dispatch({ type: ActionProduct.IS_LOADING, value: false });
      resolve(data);
    });
  });
};

const getDataJacketById = (id) => {
  const starCountRef = ref(db, `jackets/${id}`);
  return new Promise((resolve) => {
    onValue(starCountRef, (snapshot) => {
      const data = snapshot.val();
      resolve(data);
    });
  });
};

const updateDataJacket = (id, data) => (dispatch) => {
  dispatch({ type: ActionProduct.IS_LOADING, value: true });
  set(ref(db, `jackets/${id}`), data)
    .then(() => {
      dispatch({ type: ActionProduct.IS_LOADING, value: false });
      dispatch({ type: ActionProduct.SUCCESS_UPDATE, value: true });
    })
    .catch((err) => message.error(err.message));
};

const deleteDataJacket = (id) => () => {
  const starCountRef = ref(db, `jackets/${id}`);
  remove(starCountRef)
    .then(() => {
      message.success('Data Delete Successfully');
    })
    .catch((err) => message.error(err.message));
};

// slider
const AddDataSlider = (data) => (dispatch) => {
  dispatch({ type: ActionProduct.IS_LOADING, value: true });
  push(ref(db, 'sliders/'), data)
    .then((res) => {
      dispatch({ type: ActionProduct.IS_LOADING, value: false });
      dispatch({ type: ActionProduct.SUCCESS_CREATE, value: true });
    })
    .catch((err) => message.error(err.message));
};

const getDataSlider = () => (dispatch) => {
  dispatch({ type: ActionProduct.IS_LOADING, value: true });
  const starCountRef = ref(db, 'sliders');
  return new Promise((resolve) => {
    onValue(starCountRef, (snapshot) => {
      const data = [];
      const dataSnapshot = snapshot.val();
      if (dataSnapshot !== null) {
        Object.keys(dataSnapshot).map((key) => {
          data.push({
            id: key,
            data: dataSnapshot[key],
          });
        });
      }
      dispatch({ type: ActionProduct.IS_LOADING, value: false });
      resolve(data);
    });
  });
};

const deleteDataSlider = (id) => () => {
  const starCountRef = ref(db, `sliders/${id}`);
  remove(starCountRef)
    .then(() => {
      message.success('Data Delete Successfully');
    })
    .catch((err) => message.error(err.message));
};



export {
  registerInitate,
  loginInitiate,
  logoutInitiate,
  loginGoogle,
  getDataUser,
  AddDataShirt,
  getShirt,
  deleteShirt,
  getShirtById,
  updateDataShirt,
  addDataTrouser,
  getDataTrouser,
  getDataTrouserById,
  updateDataTrouser,
  deleteDataTrouser,
  AddDataJacket,
  getDataJacket,
  getDataJacketById,
  updateDataJacket,
  deleteDataJacket,
  AddDataSlider,
  getDataSlider,
  deleteDataSlider,
};